import GenericTable from 'src/components/GenericTable/GenericTable.vue';
export default function getGenericTableComponent(params) {
    return GenericTable;
}
